import { clearErrorCompra } from './compra';

export const limpiarLocalStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('usuario');
  localStorage.removeItem('usuarioId');
  clearErrorCompra();
  localStorage.removeItem('datosCompra');
  localStorage.removeItem('usuarioAEditar');
  localStorage.removeItem('alquilerAEditar');
  localStorage.removeItem('expiracionCompra');
  localStorage.removeItem('tokenExpirado');
  localStorage.removeItem('editarOtroUsu');
};
